import { initMainNavKeyboardNavigation } from './keyboard-navigation/main-nav.js';
import { initUtilityNavKeyboardNavigation } from './keyboard-navigation/utility-nav.js';
import { initMobileNavKeyboardNavigation } from './keyboard-navigation/mobile-nav.js';

function keyboardFocusClass(elem) {
	elem.addClass('keyboard-focus').on('blur', function () {
        $(this).off('blur').removeClass('keyboard-focus');
    });

    return elem;
}

function keyboardFocus(elem) {
	elem.get(0).focus();

	return elem;
}

function initKeyboardNavigation() {
	initMainNavKeyboardNavigation();

    initUtilityNavKeyboardNavigation();

    initMobileNavKeyboardNavigation();
}

export { keyboardFocusClass, keyboardFocus, initKeyboardNavigation };